<template>
    <span>
        <AddJobNumberDialog
            :is-open="addJobNumberDialog"
            @on-confirm="saveJobNumber"
            @on-close="closeJobNumberDialog"
        />
        <v-dialog
            :value="isOpen"
            scrollable
            max-width="500px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card
                class="text-center"
            >
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Dodaj gumę
                    </h1>
                </v-card-title>

                <v-card-text>
                    <v-container class="pa-0">
                        <v-row>
                            <v-col cols="12" class="pb-0">
                                <v-autocomplete
                                    v-model="customer"
                                    label="Klient"
                                    :items="customersFound"
                                    :filter="customFilter"
                                    :loading="actionLoading.customerSearchLoading"
                                    :search-input.sync="customerSearchQuery"
                                    class="v-text-field--placeholder-dark"
                                    item-text="name"
                                    return-object
                                    outlined
                                    dense
                                    :error-messages="customerIdErrors"
                                    required
                                    no-data-text="Nie znaleziono"
                                    @change="changeCustomer"
                                >
                                    <template slot="no-data">
                                        <v-list-item>
                                            <v-list-item-title>
                                                <template v-if="!customerSearchQuery">
                                                    Wpisz treść aby odnaleźć <strong>klienta</strong>.
                                                </template>
                                                <template v-else-if="customerSearchQuery.length < customerSearchQueryMinLength">
                                                    Wpisz przynajmniej <strong>{{ customerSearchQueryMinLength }}</strong> znaki.
                                                </template>
                                                <template v-else-if="actionLoading.customerSearchLoading">
                                                    Trwa wyszukiwanie klienta...
                                                </template>
                                                <template v-else>
                                                    Nie odnaleziono klienta na zapytanie: "<strong> {{ customerSearchQuery }}".</strong>
                                                </template>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                                <v-autocomplete
                                    v-model="mainJobNumber"
                                    :items="mainJobNumbers"
                                    :search-input.sync="mainJobNumbersSearch"
                                    :loading="mainJobNumbersLoading"
                                    :error-messages="mainJobNumberErrors()"
                                    class="v-text-field--placeholder-dark"
                                    label="Główny numer zlecenia"
                                    required
                                    dense
                                    chips
                                    deletable-chips
                                    item-text="number"
                                    item-value="number"
                                    no-data-text="Nie znaleziono"
                                    clearable
                                    @change="changeMainJobNumber"
                                    @input="selectMainJobNumber"
                                >
                                    <template slot="no-data">
                                        <v-list-item>
                                            <v-list-item-title>
                                                <template v-if="!mainJobNumbersSearch">
                                                    Wpisz treść aby odnaleźć <strong>zlecenie</strong>.
                                                </template>
                                                <template v-else-if="mainJobNumbersSearch.length < mainJobNumbersSearchMinQueryLength">
                                                    Wpisz przynajmniej <strong>{{ mainJobNumbersSearchMinQueryLength }}</strong> znaki.
                                                </template>
                                                <template v-else-if="mainJobNumbersLoading">
                                                    Trwa wyszukiwanie zleceń ...
                                                </template>
                                                <template v-else>
                                                    Nie odnaleziono zleceń  na zapytanie: "<strong> {{ mainJobNumbersSearch }}".</strong>
                                                </template>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </template>
                                    <template slot="append-outer">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    v-on="on"
                                                    @click="showAddJobNumberDialog"
                                                >
                                                    <v-icon color="primary">
                                                        mdi-plus
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Dodaj numer zlecenia</span>
                                        </v-tooltip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model.number="impositionNumber"
                                    label="Numer montażu"
                                    :error-messages="impositionNumberErrors()"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="jobName"
                                    label="Nazwa zlecenia"
                                    :readonly="!canChangeJobName"
                                    :error-messages="jobNameErrors()"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <v-select
                                    v-model="serialNumber"
                                    :items="serialNumberList"
                                    :error-messages="serialNumberErrors()"
                                    item-value="serialNumber"
                                    item-text="serialNumber"
                                    label="Numer porządkowy"
                                    no-data-text="Brak danych..."
                                    outlined
                                    dense
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        @click="createRubber"
                    >
                        Zapisz
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>

import AddJobNumberDialog from '@/views/Configurations/RubberRegistry/AddJobNumberDialog'
import { required, numeric, minValue } from 'vuelidate/lib/validators'
import customFilters from '@/mixins/customFilters'
import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'

let customerSearchTimer
let searchTimer

export default {
    name: 'AddRubberDialog',
    components: {
        AddJobNumberDialog
    },
    mixins: [
        customFilters,
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            actionLoading: {
                customerSearchLoading: false
            },
            customerSearchQuery: null,
            customerSearchQueryMinLength: 3,
            customersFound: [],
            customer: null,
            customerId: null,
            mainJobNumbers: [],
            mainJobNumbersLoading: false,
            mainJobNumbersSearch: this.$parent.$attrs.order,
            mainJobNumbersSearchMinQueryLength: 3,
            mainJobNumber: null,
            impositionNumber: null,
            jobName: null,
            canChangeJobName: true,
            serialNumberList: [],
            serialNumber: null,
            addJobNumberDialog: false,
        }
    },
    validations() {
        return {
            customerId: { required },
            mainJobNumber: { required },
            impositionNumber: {
                required,
                numeric,
                minValue: minValue(1)
            },
            jobName: { required },
            serialNumber: { required },
        }
    },
    computed: {
        customerIdErrors() {
            const errors = []

            if (!this.$v.customerId.$dirty) return errors
            !this.$v.customerId.required && errors.push('Proszę wybrać klienta.')

            return errors
        },
    },
    watch: {
        isOpen(value) {
            value && this.getDeletedRubbers()
        },
        customerSearchQuery(value = null) {
            if (value === null || value.length < this.customerSearchQueryMinLength || value === this.customer?.name) return

            this.actionLoading.customerSearchLoading = true

            clearTimeout(customerSearchTimer)

            customerSearchTimer = setTimeout(() => {
                if (value) {
                    this.searchCustomers(value)
                } else {
                    this.actionLoading.customerSearchLoading = false
                    this.customersFound = []
                }
            }, 500)
        },
        mainJobNumbersSearch(value = null) {
            if (value === null || value.length < this.mainJobNumbersSearchMinQueryLength) return

            this.mainJobNumbersLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchJobNumbers(value)
                } else {
                    this.mainJobNumbersLoading = false
                }
            }, 500)
        },
    },
    methods: {
        getDeletedRubbers() {
            this.$store.dispatch('configurations/getDeletedRubbers')
                .then(response => {
                    this.serialNumberList = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createRubber() {
            this.$v.$touch()

            if (this.$v.$invalid) return

            const payload = {
                customerId: this.customerId,
                mainJobNumber: this.mainJobNumber,
                impositionNumber: this.impositionNumber,
                jobName: this.jobName,
                serialNumber: this.serialNumber,
            }

            this.$store.dispatch('configurations/createRubber', payload)
                .then(() => {
                    this.$store.dispatch('showNotification', {
                        type: 'success',
                        message: 'Guma została dodana.'
                    })
                    this.$emit('on-success')
                    this.onClose()
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeCustomer(customer) {
            if (customer) {
                this.customerId = customer.id
            } else {
                this.customerId = null
            }
        },
        searchCustomers(query = '') {
            this.$store.dispatch('customers/getCustomers', {
                paginate: '?limit=20',
                query: `&isHidden=false&name=${query}`
            })
                .then(response => {
                    this.customersFound = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.customerSearchLoading = false
                })
        },
        searchJobNumbers(value) {
            this.$store.dispatch('jobs/getJobs', {
                query: `?limit=20&search=${value}`,
            })
                .then(response => {
                    this.mainJobNumbers = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.mainJobNumbersLoading = false
                })
        },
        changeMainJobNumber() {
            this.mainJobNumbersSearch = null
            if (this.mainJobNumber === null) {
                this.jobName = null
                this.canChangeJobName = true
            }
        },
        selectMainJobNumber(value) {
            const jobNumber = this.mainJobNumbers.find(job => job.number === value)

            if (jobNumber) {
                this.jobName = jobNumber.name || null
                this.canChangeJobName = false
            }
        },
        showAddJobNumberDialog() {
            this.addJobNumberDialog = true
        },
        closeJobNumberDialog() {
            this.addJobNumberDialog = false
        },
        saveJobNumber(number) {
            if (number) {
                this.mainJobNumbers.push(number)
                this.mainJobNumber = number
                this.jobName = null
                this.canChangeJobName = true
            }
            this.closeJobNumberDialog()
        },
        mainJobNumberErrors() {
            const errors = []

            if (!this.$v.mainJobNumber.$dirty) return errors
            !this.$v.mainJobNumber.required && errors.push('Numer zlecenia jest wymagany.')

            return errors
        },
        impositionNumberErrors() {
            const errors = []

            if (!this.$v.impositionNumber.$dirty) return errors
            !this.$v.impositionNumber.required && errors.push('Numer montażu jest wymagany.')
            !this.$v.impositionNumber.numeric && errors.push('Numer montażu musi być liczbą.')
            !this.$v.impositionNumber.minValue && errors.push('Numer montażu musi być większy niż 0.')

            return errors
        },
        jobNameErrors() {
            const errors = []

            if (!this.$v.jobName.$dirty) return errors
            !this.$v.jobName.required && errors.push('Nazwa zlecenia jest wymagana.')

            return errors
        },
        serialNumberErrors() {
            const errors = []

            if (!this.$v.serialNumber.$dirty) return errors
            !this.$v.serialNumber.required && errors.push('Numer porządkowy jest wymagany.')

            return errors
        },
        onClose() {
            setTimeout(() => {
                this.$v.$reset()
                this.customer = null
                this.customerId = null
                this.customersFound = []
                this.mainJobNumbers = []
                this.mainJobNumber = null
                this.impositionNumber = null
                this.jobName = null
                this.canChangeJobName = true
                this.serialNumber = null
            }, 100)
            this.$emit('on-close')
        }
    }
}
</script>
